// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"9df5cf38","453":"41576f0c","732":"516aaed9"}[chunkId] + ".chunk.js";
};